/**
 * @Author: Zewei
 * @Date:   2018-01-29T10:00:21+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-02-01T09:56:38+08:00
 */

import { DepartmentStructure } from '../constants/department-structure-constants.js';

const initState = {
    actionStatus: false,
    dutyListStatus: false,
    dutyCategoryList: [],
    dutyCategoryListStatus: false,
    dutyLevelListStatus: false,
    dutyLevelList: [],
    dutyLevelType: [],
    initDutyStatus: false,
    positionList: [],
    positionListStatus: false,
    initPosition: false,
    initPositionStatus: false,
}

export default function departmentStructure (state = initState, action) {
  switch (action.type) {
      // 组织结构
      case DepartmentStructure.ActionTypes.FETCHDATA:
          return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.FETCHSUCCESS:
          return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.FETCHFAILURE:
          return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.UPDATESUCCESS:
          return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.UPDATEFAILURE:
          return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.CREATESUCCESS:
          return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.CREATEFAILURE:
          return {...state, ...action.payload};
      // 职务规划
      case DepartmentStructure.ActionTypes.FETCHDUTYCATEGORYLISTSUCCESS:
      case DepartmentStructure.ActionTypes.CLOSEDUTYCATEGORYMODAL:
      case DepartmentStructure.ActionTypes.FETCHDEPARTMENTDUTYLISTSUCCESS:
        return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.CHANGEDUTYNAME:
        let copyState = {...state};
        copyState.dutyCategoryList[action.payload.index].name = action.payload.name;
        return copyState;
      case DepartmentStructure.ActionTypes.NEWDUTYCATEGORYSUCCESS:
        let newCopyState = {...state};
        newCopyState.dutyCategoryList.push(action.payload.item);
        return newCopyState;
      case DepartmentStructure.ActionTypes.ADDDUTYCATEGORYSUCCESS:
        let addCopyState = {...state};
        addCopyState.dutyCategoryList[action.payload.index].id = action.payload.id;
        delete addCopyState.dutyCategoryList[action.payload.index].unsave;
        return addCopyState;
      case DepartmentStructure.ActionTypes.SAVEDUTYCATEGORYSUCCESS:
        let putCopyState = {...state};
        putCopyState.dutyCategoryList[action.payload.index].name = action.payload.item.name;
        return putCopyState;
      case DepartmentStructure.ActionTypes.DELETEDUTYCATEGORYSUCCESS:
        let deleteCopyState = {...state};
        deleteCopyState.dutyCategoryList.splice(action.payload.index, 1);
        return deleteCopyState;
      // 职务等级
      case DepartmentStructure.ActionTypes.FETCHDUTYLEVELSUCCESS:
        return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.CLOSEDUTYLEVELMODAL:
        return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.NEWDUTYLEVEL:
        let copyNewDutyLevel = {...state};
        copyNewDutyLevel.dutyLevelList.push(action.payload.item);
        return copyNewDutyLevel;
      case DepartmentStructure.ActionTypes.CHANGEDUTYLEVEL:
        let copyChangeDutyLevel = {...state};
        copyChangeDutyLevel.dutyLevelList[action.payload.index][action.payload.column] = action.payload.value;
        return copyChangeDutyLevel;
      case DepartmentStructure.ActionTypes.CHANGEDUTYLEVELCHILD:
        let copyChangeChildDutyLevel = {...state};
        copyChangeChildDutyLevel.dutyLevelList[action.payload.index].type_levels[action.payload.childIndex].l_value =
          action.payload.value;
        return copyChangeChildDutyLevel;
      case DepartmentStructure.ActionTypes.ADDDUTYLEVELSUCCESS:
        let copyAddDutyLevel = {...state};
        delete copyAddDutyLevel.dutyLevelList[action.payload.index].unsave;
        copyAddDutyLevel.dutyLevelList[action.payload.index].id = action.payload.id;
        return copyAddDutyLevel;
      case DepartmentStructure.ActionTypes.DELETEDUTYLEVELSUCCESS:
        let copyDeleteDutyLevel = {...state};
        copyDeleteDutyLevel.dutyLevelList.splice(action.payload.index, 1);
        return copyDeleteDutyLevel;
      // 职务
      case DepartmentStructure.ActionTypes.INITDUTYSUCCESS:
      case DepartmentStructure.ActionTypes.CLOSEDUTYMODAL:
      case DepartmentStructure.ActionTypes.UPDATEDUTYSUCCESS:
      case DepartmentStructure.ActionTypes.ADDDUTYSUCCESS:
        return {...state, ...action.payload};
      // 职位配置
      case DepartmentStructure.ActionTypes.FETCHDEPARTMENTPOSITIONLISTSUCCESS:
      case DepartmentStructure.ActionTypes.INITPOSITIONSUCCESS:
      case DepartmentStructure.ActionTypes.INITMOVEPOSITIONSUCCESS:
        return {...state, ...action.payload};
      case DepartmentStructure.ActionTypes.UPDATEPOSITIONSUCCESS:
        let copyUpdatePosition = { ...state };
        copyUpdatePosition.positionList[action.payload.index] = action.payload.position;
        return copyUpdatePosition;
      case DepartmentStructure.ActionTypes.CREATENEWDEPARTMENTEXSUCCESS:
        return { ...state, ...action.payload };
      case DepartmentStructure.ActionTypes.UPDATEDEPARTMENTINITSUCCESS:
        return { ...state, ...action.payload };
      default:
          return {...state};
  }
}



// WEBPACK FOOTER //
// ./src/reducers/department-structure-reducer.js